// extracted by mini-css-extract-plugin
module.exports = {"logo":"Footer_logo__1d9L0"};